export default "__VITE_ASSET__DF9u71GG__"